import React, { useState } from 'react';
import {
    BoxedRow,
    Callout,
    ButtonPrimary,
    IconInformationUserRegular,
    ButtonFixedFooterLayout,
    RadioGroup,
    BoxedRowList,
    IconNoHiddenBillsLight,
    skinVars,
    Text3,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import HeaderComponent from '../../../../components/HeaderComponent';
import { useNavigate } from 'react-router-dom';
import { cancelChangeOwner } from '../../../../services/OwnershipChangeService';
import { useChangeOwnershipContext } from '../../../../context/change-ownership-context/ChangeOwnershipContext';

export const CancelChangeOwner: React.FC = () => {
    const [cancelRequest, setCancelRequest] = useState('');
    const navigate = useNavigate();
    const navigationBackHandler = () => navigate('/profile/personal-data');
    const { dataChangeOwnership } = useChangeOwnershipContext();

    const handleButtonContinue = async () => {
        try {
            await cancelChangeOwner(dataChangeOwnership?.signalingId!);
            navigate('/change-ownership/feedback?status=CANCEL');
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='cancelOwnerChange-page'>
            <HeaderComponent
                title={t('cancelRequestTitle')}
                navigationBarOnBack={navigationBackHandler}
                breadcrumbs={[
                    { title: t('profileTitle'), url: '/profile' },
                    { title: t('profilePersonalInformation'), url: `/profile/personal-data` },
                    { title: t('ChangeOfOwnership'), url: `/change-ownership` },
                ]}
            />
            <div className='cancelOwnerChange-page__content'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary disabled={!cancelRequest} onPress={handleButtonContinue}>
                            {t('continue')}
                        </ButtonPrimary>
                    }
                >
                    <div className='cancelOwnerChange-page__inner-content'>
                        <div>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('cancelChangeOwnershipInProgress')}
                            </Text3>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('cancelChangeOwnershipInProgressDescription')}
                            </Text3>
                            <div className='cancelOwnerChange-page__rows-container'>
                                <RadioGroup
                                    name={'cancelRequest'}
                                    value={cancelRequest}
                                    onChange={(value) => setCancelRequest(value)}
                                >
                                    <BoxedRowList>
                                        <BoxedRow
                                            asset={<IconNoHiddenBillsLight size={24} />}
                                            title={t('cancelRequestTitle')}
                                            description={t('cancelRequestDescription')}
                                            radioValue='cancel'
                                        />
                                    </BoxedRowList>
                                </RadioGroup>
                            </div>
                        </div>

                        <div className='cancelOwnerChange-page__callout--bottom'>
                            <Callout
                                asset={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
                                title={t('')}
                                description={t('cancelcalloutBottomDescription')}
                            />
                        </div>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        </div>
    );
};

export default CancelChangeOwner;
